import { render, staticRenderFns } from "./Question1.vue?vue&type=template&id=75b7ce0c&scoped=true&"
import script from "./Question1.vue?vue&type=script&lang=js&"
export * from "./Question1.vue?vue&type=script&lang=js&"
import style0 from "./Question1.vue?vue&type=style&index=0&id=75b7ce0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b7ce0c",
  null
  
)

export default component.exports